import React from 'react';
import { SummariesProvider } from './context/SummariesUIContext';
import { Box, Card } from '@mui/material';
import ProductsDropMenu from '../../products/ProductsDropMenu';
import SummariesTable from './table/SummariesTable';
import Summariesheader from './SummariesHeader';

export default function Collections () {
    return (
        <SummariesProvider>
            <Box display='flex' flexDirection='column' justifyContent='center' width='100%' marginRight={'2rem'}>
                <Box style={{ borderRadius: '4px', marginTop: '1rem', width: '100%', margin: '1rem 1rem 0 1rem' }}>
                    <Card sx={{ boxShadow: 'none' }}>
                        <Summariesheader />
                    </Card>
                </Box>
                <div className='menuFlex'>
                    <div className='menuFlexLeft'>
                        <ProductsDropMenu />
                    </div>
                    <div className='menuFlexRight'>
                        <SummariesTable />
                    </div>
                </div>
            </Box>
        </SummariesProvider>
    );
}
